/* global lama, DocumentTouch */
(function ($) {
  const lamaSearch = document.querySelectorAll('.lama-search');
  let request;
  let lastFormData; // Used to check if the filters have been changed

  // This is going to be set to FALSE when using the buil-in LOAD MORE button.
  let clearContainer = true;

  /**
   * Detect if the device has touch screen
   * https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript#4819886
   */
  function isTouchDevice() {
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    const mq = function (query) {
      return window.matchMedia(query).matches;
    };

    if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
      return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
  }

  /**
   * Close all the custom dropdowns
   */
  function closeDropdowns() {
    const dropdowns = document.querySelectorAll('.lama__dropdown');
    const transitionEnd = whichTransitionEvent();

    dropdowns.forEach(dropdown => {
      if (!dropdown.classList.contains('visible')) {
        return;
      }

      /**
       * Hide the element when the animation is done
       */
      if (transitionEnd) {
        const list = dropdown.querySelector('.lama__dropdown__list');
        list.style.height = '0';

        list.addEventListener(transitionEnd, function hideBlock() {
          this.style.display = 'none';
          this.removeEventListener(transitionEnd, hideBlock);
        });
      } else {
        dropdown.style.display = 'none';
      }

      dropdown.classList.remove('visible');
    });
  }

  /**
   * Get all the data from the serialized form and "append" all the filters
   * to the URL, with the exception of the one starting with `lama-`.
   */
  function updateUrl(formData) {
    const values = formData.split('&');
    const urlData = [];
    let queryUrl = '';
    const search = window.location.search.substr(1);
    const urlParameters = search ? JSON.parse(
      `{"${decodeURI(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')}"}`
    ) : {};

    /**
     * Only the keys not starting with lama- and not empty, please :)
     */
    values.forEach(value => {
      if (value.indexOf('posts-') === -1 && value.indexOf('query-') === -1) {
        const parts = value.split('=');
        const v = parts[1];

        // If the key already exists in the URL need to remove it from the latter.
        if (urlParameters[v]) {
          delete urlParameters[v];
        }

        if (v.length > 0) {
          urlData.push(value);
        }
      }

      // get the pages base url with no pagination or filtering.
      if (value.indexOf('posts-base_url') === 0) {
        queryUrl = decodeURIComponent(value.split('=')[1]);
      }
    });

    /**
     * If `parameters` contains only `query=` there is nothing to do here
     */
    if (urlData.length === 1 && urlData[0].indexOf('query') >= 0) {
      return;
    }

    // Append the parameters that exists from the url.
    Object.keys(urlParameters).forEach(parameterKey => {
      const value = urlParameters[parameterKey];

      urlData.push(`${parameterKey}=${value}`);
    });

    /**
     * Update the URL without refresh
     */
    const parameters = urlData.join('&');
    const qmark = parameters.length ? '?' : '';
    const url = `${queryUrl}${qmark}${parameters}`;

    window.history.pushState({}, '', url);
  }

  /**
   * Perform the ajax request.
   *
   * @param {string} data serialized data.
   */
  function doAjax($form, formData, $container) {
    if (request) {
      request.abort();
    }

    $('body').trigger('lamaStart', [$form, $container]);

    const data = {
      action: 'nine3_lama',
      nonce: lama.nonce,
      lamaFilter: true,
      lamaName: $form.attr('name'),
      lamaAppend: !clearContainer,
      params: formData,
      uid: $form.data('uid'),
    };

    $form.removeClass('lama--done');

    request = $.ajax({
      type: 'POST',
      url: lama.ajaxurl,
      data,
      success(response) {
        /**
         * Remove all the children
         */
        if (clearContainer) {
          $container.empty();
        }

        const $items = $(response);

        if ($items.length) {
          $items.not('.lama-posts-found').addClass('loaded');

          $container.append($items);

          // There are more elements to load?
          const foundPosts = parseInt($container.find('lama-found').html(), 10);
          const lamaPostsCount = parseInt($container.find('lama-posts-count').html(), 10);
          const lamaOffset = parseInt($container.find('lama-offset').html(), 10);

          $form.find('input[name="posts-offset"]').val(lamaOffset);
          if (lamaOffset + lamaPostsCount >= foundPosts) {
            $form.addClass('lama-more--none');
          }

          /**
           * Update the label for founded posts, if any.
           */
          const $postsFound = $form.find('.lama-posts-found__label');
          if ($postsFound.length) {
            $postsFound.html($container.find('lama-posts-found-label').html());
          }

          // Don't need the custom <lama-*> tags anymore
          $container.find('lama-found').remove();
          $container.find('lama-offset').remove();
          $container.find('lama-posts-count').remove();
          $container.find('lama-posts-found-label').remove();

          $form.removeClass('lama--ajax');
          $form.addClass('lama--done');
        } else {
          // No more items.
          $form.addClass('lama-more--none');
        }

        clearContainer = true;

        $('body').trigger('lamaDone', [$container, $items]);
      },
    });
  }

  /**
   * Prevent the form submission and do the ajax request.
   */
  function submitForm(form, event) {
    if (!form.classList.contains('lama')) {
      return true;
    }

    if (event) {
      event.preventDefault();
    }

    // The ajax process is started
    const $form = $(form);

    /**
     * Update the "lama-more" property:
     *
     * 0 => no load more (so ignore the offset parameter)
     * 1 => load more
     */
    $form.find('input[name="lama-more"]').val(clearContainer ? 0 : 1);

    const formData = $form.serialize();
    const $container = $form.find('.lama-container');

    /**
     * The form is submitted every time you click on a filter, even if you have selected the same option.
     * So, to avoid uploading the content when no filter has changed, we're going to compare the current
     * formData with the one used for the previous request.
     *
     * If something has changed, we perform the request, if not we ignore everything :)
     *
     * But this is true only when clearContainer is set to false.
     */
    // eslint-disable-next-line eqeqeq
    if (clearContainer && formData == lastFormData) {
      return false;
    }
    lastFormData = formData;

    $form.addClass('lama--ajax');

    /**
     * Update the URL with the filters selected
     */
    updateUrl(formData);

    /**
     * Perform the ajax request
     */
    doAjax($form, formData, $container);

    return false;
  }

  /**
   * Reset the fields within the form.
   */
  function clearForm(form) {
    const elements = form.elements;
    form.reset();

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const fieldType = element.type.toLowerCase();
      switch (fieldType) {
        case 'text':
        case 'password':
        case 'textarea':
        case 'hidden':
          element.value = '';
          break;
        case 'radio':
        case 'checkbox':
          if (element.checked) {
            element.checked = false;
          }
          break;
        case 'select':
        case 'select-one':
        case 'select-multi':
          element.selectedIndex = 0;
          break;
        default:
          break;
      }
    }
  }

  /**
   * Collapse the dropdown when clicking outside it.
   */
  document.addEventListener('click', e => {
    let target = e.target;
    let parent = target.parentNode;

    // Am I clicking any of the <span> element inside the "lama__dropdown__selected" button?
    if (parent.classList.contains('lama__dropdown__selected')) {
      target = parent;
      parent = target.parentNode;
    }

    // Check if the current element is already open
    const isOpen = parent.classList.contains('visible');

    // Close all the dropdowns (included this one)
    closeDropdowns();

    // If the element was open before calling closeDropdowns don't need to do anything else!
    if (isOpen) {
      return;
    }

    // Am I clicking on the custom select button?
    if (target.classList.contains('lama__dropdown__selected')) {
      /**
       * Toggle the list height
       */
      const list = target.nextSibling;

      // list.style.setProperty('--max-height', 0);
      // list.style.setProperty('--max-height', `${list.children[0].clientHeight}px`);
      list.style.maxHeight = 'none';
      list.style.height = '0px';
      list.style.display = 'block';
      list.style.height = `${list.children[0].clientHeight}px`

      parent.classList.add('visible');

      e.stopPropagation();

      // Am I clicking on the custom select single item?
    } else if (target.classList.contains('lama__dropdown__list__button')) {
      /**
       * When submitting the form with AJAX, need to update the <select>
       * as the button itself is not part of the value got from
       * $form.serialize();
       */
      const name = target.getAttribute('name');
      // IE doesn't support .closest on a JS node.
      const form = $(target).closest('form')[0];
      const select = form.querySelector(`select[data-filter="${name}"]`);

      // The span "selected" label
      const lama = $(target).closest('.lama__dropdown')[0];
      const label = lama.querySelector('.lama__dropdown__selected__label');

      select.value = target.value;

      // Update the <span> label
      label.innerHTML = target.innerHTML;

      // Am I clicking on the custom checkbox / radio filters?
    } else if (
      target.classList.contains('lama-filter') &&
      target.type &&
      ['checkbox', 'radio'].indexOf(target.type) >= 0
    ) {
      /**
       * Checkboxes and radio boxes will automatically trigger the form submit
       */
      const form = $(target).closest('form')[0];
      submitForm(form);
    }
  });

  /**
   * Search input trigger load on change
   */
  lamaSearch.forEach(input => {
    // IE doesn't support .closest on a JS node.
    const form = $(input).closest('form.lama')[0];

    const debounce = parseInt(input.getAttribute('data-debounce'), 10) || 200;
    let timeout = null;

    input.addEventListener('input', () => {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        submitForm(form);
      }, debounce);
    });
  });

  function whichTransitionEvent() {
    const el = document.createElement('fakeelement');
    const transitions = {
      transition: 'transitionend',
      OTransition: 'oTransitionEnd',
      MozTransition: 'transitionend',
      WebkitTransition: 'webkitTransitionEnd',
    };
    const keys = Object.keys(transitions);

    for (let i = 0, l = keys.length; i < l; i++) {
      const key = keys[i];

      if (el.style[key] !== undefined) {
        return transitions[key];
      }
    }

    return null;
  }

  /**
   * When clicking on the "LOAD MORE" button we have to keep the items in the container
   */
  $('body')
    .on('click', '.lama-submit', () => {
      clearContainer = false;
    })
    .ready(() => {
      if (isTouchDevice()) {
        $('form.lama').addClass('is-touch');
      }

      // Serialize the data of the form
      lastFormData = $('form.lama')
        .first()
        .serialize();
    })
    /**
     * On select change (for touch devices only) we need to trigger the form submit
     * When using not touch devices this event have to be ignored, because the styled dropdown
     * will take care of emitting the signal!
     *
     * This event has also to be triggered when not using the "styled" dropdown.
     */
    .on('change', '.lama__select', function () {
      const $this = $(this);
      const $form = $this.closest('form');

      if ($form.hasClass('is-touch') || $this.hasClass('default-style')) {
        submitForm($form.get(0));
      }
    });

  /**
   * Submit the form using AJAX
   */
  document.addEventListener('submit', event => {
    submitForm(event.target, event);
  });

  /**
   * Reset the form when using <input type="reset"> button
   */
  document.addEventListener('reset', event => {
    clearForm(event.target);
  });
}(jQuery));
